import { render } from "./DeleteTerms.vue?vue&type=template&id=7de4a846"
import script from "./DeleteTerms.vue?vue&type=script&lang=js"
export * from "./DeleteTerms.vue?vue&type=script&lang=js"
script.render = render

export default script